// @flow
import * as React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';

import Box from 'sail/Box';
import {Badge} from '../../core/Badge/Badge';
import {Heading} from '../../core/Heading/Heading';
import {List} from '../../core/List/List';
import {ListItem} from '../../core/List/ListItem';

import './Changelog.scss';

type Change = {|description: ?string, severe_description?: string|};

type Version = [string, Array<Change>];

type Props = {|
  list: Array<Version>,
|};

const messages = defineMessages({
  empty: {
    id: 'docsShell.changelog.empty',
    description: 'Message to show when a changelog version is empty',
    defaultMessage:
      '(Changes introduced in this version have since been removed.)',
  },
});

export const Changelog = (props: Props) => {
  return (
    <section>
      {props.list.map((version) => (
        <Box>
          <Heading id={version[0]} level={3} anchored>
            {version[0]}
          </Heading>
          <List>
            {version[1].length ? (
              version[1].map((item) => (
                <ListItem>
                  {item.severe_description && (
                    <Badge color="green" label="Major" />
                  )}
                  {item.description}
                </ListItem>
              ))
            ) : (
              <ListItem>
                <FormattedMessage {...messages.empty} />
              </ListItem>
            )}
          </List>
        </Box>
      ))}
    </section>
  );
};
